import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const PlayFilledSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.49064 13.2622C4.45969 14.3199 3.44422 14.8488 2.72211 14.2471C2 13.6453 2 12.2703 2 9.52019V6.47981C2 3.72971 2 2.35466 2.72211 1.75294C3.44422 1.15121 4.45969 1.68008 6.49064 2.73781L9.40956 4.258C12.4699 5.85181 14 6.64872 14 8C14 9.35127 12.4699 10.1482 9.40959 11.742L6.49064 13.2622ZM3.45 13.1002C3.44502 13.1001 3.44212 13.1005 3.44212 13.1005C3.44212 13.1005 3.44548 13.101 3.45377 13.1003L3.45 13.1002ZM3.45377 2.89972C3.44652 2.90008 3.44212 2.89945 3.44212 2.89945C3.44212 2.89945 3.44548 2.899 3.45377 2.89972Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const PlayFilledSize16 = hoc(forwardRef(PlayFilledSize16Component), 'PlayFilledSize16');

export { PlayFilledSize16 as default };
//# sourceMappingURL=PlayFilledSize16.js.map
